<template>
  <div class="dashboard-container">
    <GrfaSidebar :year="selectedYear"/>
    <div :class="$route.name !== 'rdv' ? 'dashboard-content' : 'dashboard-content-no-header'">
      <div v-if="$route.name !== 'rdv'" class="white-box dashboard-header">
        {{ currentDate }}
        <div class="right">
          <label class="global-view-checkbox">
            Vue&nbsp;globale
            <input type="checkbox" v-model="store.globalView"/>
          </label>
          <select v-model="selectedYear" class="form-select">
            <option v-for="p of periods" :value="p" :key="p">
              Campagne {{ p }}
            </option>
          </select>
          <div class="initials">{{ userInitials }}</div>
        </div>
      </div>
      <router-view :year="selectedYear" :detailed-periods="detailedPeriods" :global-view="store.globalView"></router-view>
    </div>
  </div>
</template>

<script>
import store from "@/store/dashboards";
import {getUserInitials} from "@/utils/user";
import {getAllPeriods, getCampaignsYear} from "@/utils/period";
import GrfaSidebar from "@/components/DashboardGRFA/GrfaSidebar.vue";

export default {
  name: "DashboardGRFA",
  components: {
    GrfaSidebar
  },
  data() {
    return {
      periods: [],
      detailedPeriods: [],
      selectedYear: null,
      store
    };
  },
  mounted() {
    getAllPeriods().then((res) => {
      this.detailedPeriods = res;
    })

    getCampaignsYear().then((res) => {
      this.periods = res;

      if (localStorage.getItem("dashboards-year")) {
        this.selectedYear = localStorage.getItem("dashboards-year");
      } else if (res.length > 0) {
        this.selectedYear = res[0];
      }
    })
  },
  watch: {
    selectedYear(val) {
      localStorage.setItem("dashboards-year", val);
    }
  },
  methods: { },
  computed: {
    userInitials() {
      return getUserInitials(this.$store.state.self.firstname + " " + this.$store.state.self.name)
    },
    currentDate() {
      const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
      const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

      const today = new Date();
      return days[today.getDay()] + " " + today.getDate() + " " + months[today.getMonth()] + " " + today.getFullYear()
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  display: grid;
  grid-template-columns: 100px 1fr;
  min-height: 100vh;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  font-size: 18px;
}

.dashboard-header .right {
  height: 100%;
  display: flex;
  align-items: center;
  column-gap: 24px;
}

.dashboard-header .right .global-view-checkbox {
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 16px;
}

.dashboard-header .right .initials {
  height: 100%;
  aspect-ratio: 1/1;
  background-color: #50E3C2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
  color: white;
  font-size: 18px;
}

.dashboard-content {
  padding: 24px;
  display: grid;
  grid-template-rows: 64px 1fr;
  row-gap: 24px;
}

.dashboard-content-no-header {
  padding: 24px;
}
</style>

<style>
.dashboard-container .btn-cmem {
  background-color: #A7C13C;
  color: black;
  padding: 8px 16px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  line-height: 1;
  box-shadow: 0px 0px 3px 1px #00000040;
}
</style>



// WEBPACK FOOTER //
// src/pages/RFA/DashboardGRFA/DashboardGRFA.vue